var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1677_237)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1677_237",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 500,
    height: 500
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V500H500V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1677_237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250 500C388.071 500 500 388.071 500 250C500 111.929 388.071 0 250 0C111.929 0 0 111.929 0 250C0 388.071 111.929 500 250 500Z",
    fill: "black",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.731 90C203.313 90 199.731 93.5817 199.731 98V125.042C183.844 132.607 171.234 146.816 166.334 165.106C166.334 165.106 164.672 170.605 164.565 170.724L130.772 296.885C122.411 328.099 102.697 339.151 92.1021 345.083C81.07 351.276 81.07 351.276 81.114 357.333C80.9076 364.986 80.8277 367.95 82.2689 369.492C83.1797 370.467 84.698 370.874 87.1756 371.538L118.417 379.911C154.895 389.688 182.202 384.583 199.731 365.192V397C199.731 401.418 203.313 405 207.731 405H222.981C227.4 405 230.981 401.418 230.981 397V362.197C243.534 365.512 258.096 369.357 269.481 372.362V397C269.481 401.418 273.063 405 277.481 405H292.731C297.15 405 300.731 401.418 300.731 397V379.47C328.92 381.408 355.476 363.682 364.173 335.943C364.214 335.957 393.874 226.091 393.874 226.091C402.75 192.958 383.017 158.771 349.893 149.893L300.731 136.717V98C300.731 93.5817 297.15 90 292.731 90H277.481C273.063 90 269.481 93.5817 269.481 98V128.342L242.515 121.114C238.671 120.084 234.813 119.439 230.981 119.156V98C230.981 93.5817 227.4 90 222.981 90H207.731ZM283.87 214.679C283.239 206.546 272.57 203.972 268.3 210.923L260.249 224.027C258.34 227.136 254.646 228.661 251.099 227.805L236.148 224.198C228.218 222.285 222.473 231.637 227.764 237.846L237.74 249.552C240.106 252.329 240.415 256.313 238.505 259.422L230.454 272.527C226.184 279.477 233.303 287.831 240.843 284.718L255.059 278.848C258.431 277.455 262.316 278.393 264.682 281.169L274.658 292.876C279.949 299.085 290.094 294.896 289.463 286.763L288.273 271.429C287.991 267.791 290.083 264.386 293.455 262.994L307.671 257.124C315.211 254.011 314.362 243.068 306.432 241.155L291.481 237.548C287.934 236.692 285.342 233.65 285.06 230.013L283.87 214.679Z",
    fill: "#F5F5F5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1677_237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/SOCIAL.81ccedc14dfa83624405f77a680f46a1.svg";
export { ForwardRef as ReactComponent };